import { DateTime } from 'luxon';

import { colors } from 'packages/common-frontend/colors';
import { dollarNumberWithCommas } from 'packages/common-frontend/utils';

/**
 * Shared display formatters for the Backup Servicing (BUS) customer portal
 * views (Deal Overview, Monthly Deliverables, …). Kept in one place so the
 * date / currency / status-colour rendering stays consistent across screens.
 */

/** JSDate scalar → epoch ms. Render as a medium date, or a dash when absent. */
export function formatJsDate(ms: number | null | undefined): string {
  if (ms === null || ms === undefined) return '—';
  return DateTime.fromMillis(ms).toLocaleString(DateTime.DATE_MED);
}

/** A FullDateStr ("YYYY-MM-DD") as a medium date (e.g. "Mar 31, 2026"). */
export function formatFullDate(value: string | null | undefined): string {
  if (!value) return '—';
  return DateTime.fromISO(value).toLocaleString(DateTime.DATE_MED);
}

/** A FullDateStr as a compact "MMM yyyy" label (e.g. "Mar 2026"). */
export function formatPeriodShort(value: string): string {
  return DateTime.fromISO(value).toFormat('LLL yyyy');
}

/** A dollar amount, or a dash when absent. */
export function formatDollars(value: number | null | undefined): string {
  if (value === null || value === undefined) return '—';
  return String(dollarNumberWithCommas(value));
}

/** Colour for a reconcile / check `status` string (pass | fail | other). */
export function statusColor(status: string): string {
  if (status === 'pass') return colors.green[400];
  if (status === 'fail') return colors.red[400];
  return colors.gray[500];
}
